import { Component } from '@angular/core';
import { EcapTranslateService } from '../../../shared/standalone-packages/ecap3/core';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    standalone: false
})
export class NotFoundComponent {
    constructor(private translateService: EcapTranslateService) {}
}
